import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Match from '@/pages/Match';
import Protocols from '@/pages/Protocols';
import ProtocolDetail from '@/pages/ProtocolDetail';
import Trials from '@/pages/Trials';
import Pricing from '@/pages/Pricing';
import PaymentStatus from '@/pages/PaymentStatus';
import Admin from '@/pages/Admin';
import LegalDisclaimer from '@/pages/LegalDisclaimer';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireRole({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (Array.isArray(role) ? !role.includes(user.role) : user.role !== role) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/match" element={<Match />} />
              <Route path="/protocols" element={<Protocols />} />
              <Route path="/protocols/:id" element={<ProtocolDetail />} />
              <Route path="/trials" element={<Trials />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment-status" element={<RequireAuth><PaymentStatus /></RequireAuth>} />
              <Route path="/admin" element={<RequireRole role="admin"><Admin /></RequireRole>} />
              <Route path="/legal/disclaimer" element={<LegalDisclaimer />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
